import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a364066c55243e9e561f08721ff4909d9b from "./generated-4ae253e6-ec22-4fcf-af40-f78a50d1b68f.json";

import a2a74b0380ebf8138cc30d301220f4c88b from "./generated-cb26ff1c-5528-40c1-803c-9deb071692ca.json";

import a95a2e15fb7c406224168069d1e90fb1bb from "./generated-c0a940d8-187f-47ef-af4b-2a9e6a97b09c.json";

import a1c285e21795228d8440c54e7b970beeeb from "./generated-6ded9930-7267-4652-8188-4eb9b0318fdb.json";

import a1ee8d76180b53f2e3fb6cdd82291de84b from "./generated-d95f7d05-2b76-42aa-9eca-2218e6dbcf5f.json";

import a9c3a0824e0d844654375479b40487a49b from "./generated-faef6d35-a761-4f71-bfcb-28b17ca9ad6a.json";

import a13072487bb849d2ca018d0a1c4d3c1e2b from "./generated-f93b33c0-8831-4765-80b2-4f62b96af38a.json";

import ac44e2c98ed41b2fbac8a55b046ba7652b from "./generated-bf838ac0-58e1-4fd9-a390-1883b751328b.json";

import a375e9e2de13385dce17838dc62055bd2b from "./generated-e925e233-b849-4bc5-aef5-3562ab0f6db5.json";

import a2eacad8ab5d478be01354c6b506547d0b from "./generated-f80b3da3-26d5-4416-97eb-2b313fdb1173.json";

import a1bfa9f2a6c1c05689b3ab8015cd9a050b from "./generated-ea44fed2-59ff-4990-94aa-7004b84027b7.json";

import a4056f2d00e0eb0cffe5811e87effb047b from "./generated-3a9f0817-2fa1-4cf8-806d-d9a9f1759797.json";

import a20c4aae7739a39a1495758f7484401d1b from "./generated-f5c7c830-b6db-40da-a981-a25c7075933b.json";

import a8504c1ddfacb06be8ad5e18d5ba08e85b from "./generated-9cdeb8c7-b1f4-4e0e-9ea9-351d1af75475.json";

import a0271cc05872094385d7f9d18bd3d9efab from "./generated-4b6f6360-cdff-4773-a801-b084e61a992b.json";

import a9e73f8d901e67a240eb5b01d87f27a69b from "./generated-354d1ff5-5d66-4ff3-90c2-e7e3f55eb6d5.json";

import ac486555995374c152125553cae0aafe6b from "./generated-31424d83-e46e-437f-ba80-c132070c38e5.json";

import ac9a752750b27a1b2f6e99c4aeb551c31b from "./generated-8e75261c-5680-4460-9808-fb4e84d04658.json";

import a0247b0b6cf98b3dce30cfede645d0411b from "./generated-189d80bd-cc0f-46da-938a-62f7510f1438.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a364066c55243e9e561f08721ff4909d9b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a2a74b0380ebf8138cc30d301220f4c88b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a95a2e15fb7c406224168069d1e90fb1bb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a1c285e21795228d8440c54e7b970beeeb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a1ee8d76180b53f2e3fb6cdd82291de84b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9c3a0824e0d844654375479b40487a49b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a13072487bb849d2ca018d0a1c4d3c1e2b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ac44e2c98ed41b2fbac8a55b046ba7652b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a375e9e2de13385dce17838dc62055bd2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a2eacad8ab5d478be01354c6b506547d0b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a1bfa9f2a6c1c05689b3ab8015cd9a050b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4056f2d00e0eb0cffe5811e87effb047b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a20c4aae7739a39a1495758f7484401d1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a8504c1ddfacb06be8ad5e18d5ba08e85b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a0271cc05872094385d7f9d18bd3d9efab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a9e73f8d901e67a240eb5b01d87f27a69b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ac486555995374c152125553cae0aafe6b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ac9a752750b27a1b2f6e99c4aeb551c31b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0247b0b6cf98b3dce30cfede645d0411b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ac486555995374c152125553cae0aafe6b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */